import { render } from "./HomeCarousel.vue?vue&type=template&id=72dde0ef"
import script from "./HomeCarousel.vue?vue&type=script&lang=ts"
export * from "./HomeCarousel.vue?vue&type=script&lang=ts"

import "./HomeCarousel.vue?vue&type=style&index=0&id=72dde0ef&lang=scss"
script.render = render

export default script